import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

@Injectable()
export class DataService_StudentMeals {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	MealHistorySelectList(PersonID) {
		var postResult$ = new Subject();
		var url = "Meals/MealHistorySelectList?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StudentAddMealInfoSelect(PersonID) {
		var postResult$ = new Subject();
		var url = "Meals/StudentAddMealInfoSelect?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MealSubsidyTypeSelectList() {
		var postResult$ = new Subject();
		var url = "Meals/MealSubsidyTypeSelectList";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MealInfoSelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "Meals/MealInfoSelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
